import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field as FormField } from 'redux-form';

const InputField = styled(FormField)`
  width: 100%;
  font-size: 16px;

  border-radius: 4px;
  margin-top: 8px;
  appearance: none;
  outline: 0;
  border: 1px solid #eee;
  position: relative;
  padding: 11px 20px;
`;

const QuestionLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
`;

export default function Input({ name, label }) {
  return (
    <QuestionLabel>
      {label}
      <InputField name={name} component="input" placeholder="" />
    </QuestionLabel>
  );
}

Input.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string
};
